module.exports = "/_next/static/images/6e4ebfc8c708309409f9cc102772b604-rewards-home-card@0.5x.png.webp";